// extracted by mini-css-extract-plugin
export default {"wrap":"MicrositeDnsVerifiedIcon_wrap__FPW10","verified":"MicrositeDnsVerifiedIcon_verified__wO1OI","pending":"MicrositeDnsVerifiedIcon_pending__M7rvk"};